<script>
/* eslint-disable */
</script>
<template>
  <v-container data-app>
    <template>
      <v-row>
        <v-col cols="2">{{ loggedUser.first_name }}</v-col>
        <v-col cols="8">&nbsp;</v-col>
        <v-col cols="2"> {{ driverFee }} Fee</v-col>
      </v-row>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker
            v-model="date"
            @input="menu = false"
            ></v-date-picker>
        </v-menu>
        <v-tabs
              v-model="tab"
              fixed-tabs
            background-color="primary"
              dark      
            >
              <v-tab
                  v-for="content in tabItems"
                  :key="content.tab"
                  @click="getTab(content)"
              >
                  {{ content.tab }}
              </v-tab>

            <v-tabs-items v-model="tab">
            <v-tab-item
                v-for="content in tabItems"
                :key="content.tab"
            >
              <v-simple-table>
                  <template v-slot:default>
                  <thead>
                      <tr>
                      <th class="text-left">
                          Order ID
                      </th>
                      <th class="text-left">
                          Address
                      </th>
                      <th class="text-left">
                          Customer
                      </th>
                      <th class="text-left">
                          Delivery Fee
                      </th>
                      <th class="text-left">
                          Total
                      </th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr
                      v-for="order in filteredOrders"
                      :key="order.id"
                      @click="selectOrder(order)"
                      >
                        <td>{{ order.id }}</td>
                        <td>{{ order.order_data.customer.address }}</td>
                        <td>{{ order.order_data.customer.name }}</td>
                        <td>{{ order.order_data.deliveryFee }}</td>
                        <td>{{ order.totalDue }}</td>
                      </tr>
                  </tbody>
                  </template>
              </v-simple-table>
          </v-tab-item>
          </v-tabs-items>
          </v-tabs>
    </template>
    <v-dialog
      v-model="dialog"
      width="500"
      v-if="isOrders"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ selectedItem.id }} 
          <br>
          Delivery Fee: {{ selectedItem.order_data.deliveryFee }}
          <br>
          Total : {{ selectedItem.total_price }}
          <br>
          Total Due : {{ selectedItem.totalDue  }} 
          <br>
          Comment : {{ selectedItem.order_data.customer.comment  }} 
        </v-card-title>
        <a :href="`tel:${ selectedItem.order_data.customer.phone }`">
          <v-btn
            class="ma-2"
            color="green"
            dark
          >
            Call Customer
          </v-btn>
        </a>
        <v-card-text>
            {{ selectedItem.order_data.customer.name }}
            <br>
            {{ selectedItem.order_data.customer.address }}
            <br>
            {{ selectedItem.order_data.customer.phone }}
            <br>
            {{ selectedItem.order_data.comment2 }}
          <v-simple-table>
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">
                  QTY
                </th>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Total Price
                </th>
                </tr>
            </thead>
            <tbody>
                <tr
                v-for="item in selectedItem.order_data.items"
                :key="item"
                >
                <td style="font-size: 18px !important;">{{ item.qty }}</td>
                <td style="font-size: 18px !important;">{{ item.name }}</td>
                <td style="font-size: 18px !important;">{{ Number(item.totalPrice) }}</td>
                </tr>
            </tbody>
            </template>
        </v-simple-table>
        <v-text-field v-if="!finishedVar" v-model="orderComment" label="Driver Comment"></v-text-field>
        <v-text-field
          label="TIP"
          v-model="tip"
          @keypress="isNumber($event)"
          prefix="GEL "
        ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!finishedVar && !activeInvoice && !activeOpay"
            class="grey mx-2"
            large
            text
            @click="splitDialog()"
          >
            Split
          </v-btn>
          <v-btn
            v-if="!finishedVar && !activeInvoice && !activeOpay"
            class="green mx-2"
            large
            text
            @click="payOrder('cash')"
          >
            Cash
          </v-btn>
          <v-btn
            v-if="!finishedVar && !activeInvoice && !activeOpay"
            class="blue mx-2"
            large
            text
            @click="payOrder('card')"
          >
            Card
          </v-btn>
          <v-btn
            v-if="!finishedVar && activeInvoice && !activeOpay"
            class="blue mx-2"
            large
            text
            @click="payOrder('invoice')"
          >
            Transfer
          </v-btn>
          <v-btn
            v-if="!finishedVar && !activeInvoice && activeOpay"
            class="blue mx-2"
            large
            text
            @click="payOrder('Opay')"
          >
            Online Payment
          </v-btn>
          <v-btn
            v-if="finishedVar"
            large
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="splitModal"
        v-if="isOrders"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            Total Due: {{ selectedItem.totalDue }} 
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="splitCash" label="Split Cash" class="my-2" ></v-text-field>
            <v-text-field v-model="splitCard" label="Split Card" class="my-2"  ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="payOrder('split')"
            >
              Pay Split
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: "Home",
  components: {},
  data() {
      return {
        tip: '',
        commentRules: [
          value => !!value || 'Required.',
        ],
        menu: false,
        date: new Date().toISOString().substr(0, 10),
        customer: {'name': '', 'address' : '', 'phone' : ''},
        isOrders: false,
        dialog: false,
        orderComment: null,
        loggedUser: {},
        driverBalance: 0,
        today: null,
        activeInvoice: false,
        activeOpay: false,
        selectedItem: {},
        selectedOrder: {},
        driverOrders: [],
        splitModal: false,
        filteredOrders: [],
        finishedVar: false,
        splitCard: 0,
        splitCash: 0,
        tab: 0,
        tabItems: [
          { tab: 'Ongoing Delivery', content: 'delivery' },
          { tab: 'Finished Orders', content: 'finished' },
        ],
      }
    },
    computed: {
        driverFee() {
            var fee = 0;
            this.driverOrders.forEach(x => {
              if(x.status == 7){
                if(x.order_data.deliveryFee == '1.5'){
                  fee = fee + 1;
                }
                else {
                  fee = fee + (x.order_data.deliveryFee / 2);
                }
              }
            });
            this.driverBalance = fee;
            return fee;
        },
    },
  mounted() {
        this.loggedUser = this.$store.state.auth.user;
        // alert(this.loggedUser.role);
        
        if (this.loggedUser.role != "driver") {
          this.$router.push({path: "login"});
        }

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        this.today = yyyy + '-' + mm + '-' + dd + ' to '+ yyyy + '-' + mm + '-' + dd;
        this.updateDriverOrders(this.date);
  },
  watch: {
    date(val){
      this.updateDriverOrders(val);
    },
  },
  created () {
        this.timer = setInterval(this.driverBalance = this.driverFee, 1000)
    },
  methods: {
    isNumber(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();         

          } else {

              if(this.search.length >= 5){
                this.checkUser(this.search);
              }
            return true;
          }    
    },
    selectOrder(item){
        this.selectedItem = item;
        if(item.order_data.paymentType == 'invoice'){
          this.activeInvoice = true;
          this.activeOpay = false;
        } else if(item.order_data.paymentType == 'Opay'){
          this.activeOpay = true;
          this.activeInvoice = false;
        } else {
          this.activeInvoice = false;
          this.activeOpay = false;
        }
        this.dialog = true;
    },
    getTab(tab){
        if(tab.content === 'delivery') {
            this.filteredOrders = this.driverOrders.filter((x) => x.status == '6');
            this.finishedVar = false;
        }
        else if(tab.content === 'finished') {
            this.filteredOrders = this.driverOrders.filter((x) => x.status == '7');
            this.finishedVar = true;
        }
        this.$forceUpdate();
    },
    splitDialog(){
      this.dialog = false;
      this.splitModal = true;
    },
    payOrder(type){
        this.selectedOrder = this.selectedItem.order_data;
        this.selectedOrder.id = this.selectedItem.id;
        this.selectedOrder.paymentType = type;
        this.selectedOrder.driverComment = this.orderComment;

        var bodyFormData=new FormData();
        bodyFormData.set("driver_id", this.loggedUser.id);
        bodyFormData.set("order_id", this.selectedItem.id);
        bodyFormData.set("payment_method", type);
        bodyFormData.set("tip", this.tip);
        bodyFormData.set("split_card", this.splitCard);
        bodyFormData.set("split_cash", this.splitCash);

        const TOKEN = this.loggedUser.token;
        axios.request({
            method: 'post',
            url: this.$hostname + 'driver/finish-order',
            headers: { 
              'Authorization': 'Bearer ' + TOKEN, 
            },
            data: bodyFormData,
          })
          .then(response => {
            console.log('paid order: ', response);
            if(response.status === 200 ){
              this.updateStatus('finished', this.selectedOrder.id);
              this.tip='';
            } 
        });
    },
    updateDriverOrders(date) {
        const TOKEN = this.loggedUser.token;
        var dateString = date + ' to '+ date;
        var bodyFormData=new FormData();
        bodyFormData.set("driver_id", this.loggedUser.id);
        bodyFormData.set("day", dateString);

        axios.request( {
                method: "post",
                url: this.$hostname + "driver/orders-by-driver",
                headers: {
                  Authorization: "Bearer " + TOKEN,
                },
                data: bodyFormData,
            }
        ) .then((response)=> {
                if(!response.data.is_error) {
                  console.log('Driver Data: ', response);
                  this.driverOrders = response.data.data;
                  this.filteredOrders = this.driverOrders.filter((x) => x.status == '6');
                  this.isOrders = true;
                }
                else {
                    console.log('No driver data: ', response);
                }
            }
        );
        this.$forceUpdate();
    },
    updateStatus(status, orderId){
        const TOKEN = this.loggedUser.token;
        var bodyFormData = new FormData();
        bodyFormData.set("order_status", status);
        bodyFormData.set("id", orderId);
        axios
          .request({
          method: "post",
          url:
              this.$hostname + "orders/change-status",
          headers: {
              Authorization: "Bearer " + TOKEN,
          },
          data: bodyFormData,
          })
          .then((response) => {
          console.log("Order Status Changed!", response);
          this.updateDriverOrders(this.date);
          this.$forceUpdate();
          this.dialog = false;
          });
    },
  },
};
</script>
<style scoped>
  .blue {
      background-color:cornflowerblue !important;
  } 

  .green {
      background-color: #49B25D !important;
  }

  .lightGreen {
      background-color: #70ec87 !important;
  }
</style>